export default "__VITE_ASSET__DX4b0Dmc__"